import { useNavigate } from 'react-router-dom';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-900">
      {/* Header */}
      <header className="flex items-center p-4 border-b border-slate-700 sticky top-0 bg-slate-900 z-10">
        <button
          onClick={() => navigate(-1)}
          className="text-slate-400 hover:text-white mr-4"
        >
          ← 뒤로
        </button>
        <h1 className="text-lg font-semibold">이용약관</h1>
      </header>

      <div className="p-4 max-w-lg mx-auto">
        <div className="prose prose-invert prose-sm max-w-none">
          <p className="text-slate-400 text-sm mb-6">
            최종 수정일: 2024년 1월 1일
          </p>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">제1조 (목적)</h2>
            <p className="text-slate-300 leading-relaxed">
              이 약관은 Debate Battle(이하 "서비스")이 제공하는 실시간 음성 토론 서비스의 
              이용조건 및 절차, 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 
              규정함을 목적으로 합니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">제2조 (정의)</h2>
            <ul className="text-slate-300 space-y-2 list-disc pl-5">
              <li>"서비스"란 회사가 제공하는 실시간 음성 토론 플랫폼을 말합니다.</li>
              <li>"회원"이란 서비스에 접속하여 이 약관에 따라 회사와 이용계약을 체결하고 서비스를 이용하는 자를 말합니다.</li>
              <li>"토론자"란 특정 주제에 대해 찬성 또는 반대 의견을 개진하는 회원을 말합니다.</li>
              <li>"배심원"이란 토론을 관전하고 투표에 참여하는 회원을 말합니다.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">제3조 (약관의 효력 및 변경)</h2>
            <ol className="text-slate-300 space-y-2 list-decimal pl-5">
              <li>이 약관은 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공지함으로써 효력이 발생합니다.</li>
              <li>회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 이 약관을 변경할 수 있습니다.</li>
              <li>변경된 약관은 공지 후 7일이 경과한 날로부터 효력이 발생합니다.</li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">제4조 (서비스의 제공)</h2>
            <p className="text-slate-300 leading-relaxed mb-3">
              회사는 다음과 같은 서비스를 제공합니다:
            </p>
            <ul className="text-slate-300 space-y-2 list-disc pl-5">
              <li>실시간 음성 토론 서비스</li>
              <li>토론 매칭 서비스</li>
              <li>배심원 투표 서비스</li>
              <li>토론 기록 및 통계 서비스</li>
              <li>기타 회사가 정하는 서비스</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">제5조 (회원의 의무)</h2>
            <ol className="text-slate-300 space-y-2 list-decimal pl-5">
              <li>회원은 타인의 명예를 손상시키거나 불이익을 주는 행위를 하여서는 안 됩니다.</li>
              <li>회원은 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 등의 방법으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.</li>
              <li>회원은 욕설, 비방, 차별, 혐오 발언 등 타인에게 불쾌감을 주는 언행을 삼가야 합니다.</li>
              <li>회원은 토론 중 개인정보를 노출하지 않도록 주의해야 합니다.</li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">제6조 (서비스 이용 제한)</h2>
            <p className="text-slate-300 leading-relaxed">
              회사는 회원이 다음 각 호에 해당하는 행위를 한 경우, 사전 통지 없이 
              서비스 이용을 제한하거나 회원 자격을 박탈할 수 있습니다:
            </p>
            <ul className="text-slate-300 space-y-2 list-disc pl-5 mt-3">
              <li>타인의 개인정보를 도용한 경우</li>
              <li>서비스 운영을 고의로 방해한 경우</li>
              <li>욕설, 비방, 차별, 혐오 발언을 한 경우</li>
              <li>불법적인 목적으로 서비스를 이용한 경우</li>
              <li>기타 관련 법령이나 이 약관을 위반한 경우</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">제7조 (면책사항)</h2>
            <ol className="text-slate-300 space-y-2 list-decimal pl-5">
              <li>회사는 천재지변, 전쟁, 서비스 설비의 장애 등 불가항력으로 인해 서비스를 제공할 수 없는 경우 책임이 면제됩니다.</li>
              <li>회사는 회원의 귀책사유로 인한 서비스 이용 장애에 대해 책임지지 않습니다.</li>
              <li>회사는 회원이 서비스를 이용하여 기대하는 수익을 얻지 못한 것에 대해 책임지지 않습니다.</li>
            </ol>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">제8조 (분쟁 해결)</h2>
            <p className="text-slate-300 leading-relaxed">
              서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 
              양 당사자는 분쟁의 해결을 위해 성실히 협의합니다. 
              협의가 이루어지지 않을 경우 대한민국 법원을 관할 법원으로 합니다.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">부칙</h2>
            <p className="text-slate-300 leading-relaxed">
              이 약관은 2024년 1월 1일부터 시행합니다.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
